<div class="container-fluid" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="!diviceXs && !diviceSm">
    <figure class="ic-diamante"></figure>

    <p> Puntos por tus compras, Compras con puntos y una comunidad donde todos ganamos... </p>

    <figure class="ic-diamante"></figure>
</div>

<div id="blackLine" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.xs="space-around center">

    <app-menu [hidden]="hidenMenu" [diviceXs]="diviceXs" [diviceSm]="diviceSm" *ngIf="diviceXs || diviceSm"></app-menu>

    <figure id="logo" (click)="closeSlidenNav()" [routerLink]="['']" fxFlex.xs="50" fxFlex.ms="10" fxFlex.md="20"></figure>

    <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="diviceXs">
        <button *ngIf="!firebaseAuthService.loguedIn" mat-icon-button color="primary" (click)="goToLogIn()">
      <i class="material-icons md-24">account_circle</i>
    </button>

        <div *ngIf="firebaseAuthService.loguedIn" id="btn-goToProfile" (click)="goToProfile()">
            <p><strong>Hola!</strong></p>
            <p>{{firebaseAuthService.displayNameObs | async}}</p>
        </div>

        <button mat-icon-button color="primary" [routerLink]="[{ outlets: { primary: ['shopping-cart'], sidebar: ['shopping-cart']}}]" routerLinkActive="router-link-active">
      <span id="itemsNum" *ngIf="userService.listProductsSession.length > 0"></span>
      <i class="material-icons md-24">shopping_cart</i>
    </button>
    </div>

    <div fxFlex="80" fxLayout="column" fxLayoutAlign="end" *ngIf="!diviceXs">

        <ul id="corporateMenu" fxLayout="row" fxLayoutAlign="space-around center">
            <li id="tel">LINEA TELEFÓNICA<br />(4)495 80 46</li>
            <li>SERVICIO AL CLIENTE</li>
            <li *ngIf="!diviceSm">CORPORACIÓN</li>
            <li *ngIf="!diviceSm">VIAJES</li>
            <li *ngIf="!diviceSm">SEGUROS</li>
            <li id="idioma">IDIOMA</li>
        </ul>

        <div id="searchContent" fxLayout="row" fxLayoutAlign="space-between center">

            <div fxFlex="50" class="container-input-search">

                <!-- <input matInput type="text" name="buscar" id="serachItem" placeholder="Lo que deseas, esta en tuGessi.com"> -->
                <app-search></app-search>

            </div>

            <div *ngIf="!firebaseAuthService.loguedIn" fxFlex id="btn-login" class="btn-search-bar" fxLayoutAlign="space-around center" (click)="goToLogIn()">

                <figure fxFlex="40"></figure>

                <div fxFlex="60" id="btn-TextLogin">
                    <p>Iniciar Sesión</p>
                </div>

            </div>

            <ng-container *ngIf="!showBtnsPerfil">
                <div *ngIf="firebaseAuthService.loguedIn" fxFlex id="btn-login" class="btn-search-bar" fxLayoutAlign="space-around center" (click)="goToProfile()">

                    <figure fxFlex="40"></figure>

                    <div fxFlex="60" id="textLogin">
                        <p>Bienvenid@</p>
                        <p>{{firebaseAuthService.displayNameObs | async}}</p>
                    </div>
                </div>
            </ng-container>


            <div fxFlex id="btn-help" class="btn-search-bar" *ngIf="!diviceXs && !diviceSm">
                <figure></figure>
                <p>AYUDA</p>
            </div>

            <div fxFlex id="btn-notifications" class="btn-search-bar" *ngIf="showBtnsPerfil">
                <figure>
                    <span id="notificationsNum">0</span>
                </figure>
                <p>Notificaciones</p>
            </div>

            <div fxFlex [routerLink]="[{ outlets: { primary: ['shopping-cart'], sidebar: ['shopping-cart']}}]" routerLinkActive="router-link-active" id="btn-car" class="btn-search-bar">
                <!-- Actualizacion items carrito -->
                <figure>
                    <span id="itemsNum">{{userService.listProductsSession.length}}</span>
                </figure>

                <p *ngIf="!diviceXs && !diviceSm">MI CARRITO</p>
            </div>


        </div>

    </div>
</div>

<app-search *ngIf="diviceXs"></app-search>

<app-menu [hidden]="hidenMenu" [diviceXs]="diviceXs" [diviceSm]="diviceSm" *ngIf="!diviceXs && !diviceSm"></app-menu>